<template lang="pug">
div.wam-container(
    id="#vuejs-app"
    :clientChoice="clientChoice"
    :theme-dark='darkInterface')

    div.overlay-close(
        v-if="displayExportForm"
        @click="closeForm()")
    div.modal.modal__medium(v-if="displayExportForm")
        FormExportData

    header.app-header.l-flex-row
        .app-header-wrapper

            router-link(
                @click.native="changeViewName('Builder')"
                :to="'/' + accountId + '/builder/segment'")
                div.logo.l-flex-row.cursor(@click="changeViewName('Builder')")
                    img(v-if="clientChoice === 'weborama'" :src="logoPath" width="40" height="40")
                    //- svg-icon( name='logo' title='Weborama' size="xlarge" )
                    svg-icon(v-else name='logo_publicis' title='Publicis Groupe' size="xlarge")
            div.account-id {{ accountLabel }}

            div.navigation-main.l-flex-row

                .nav-item.has-dropdown(:class="{'is-active': cmpLinkDashboard}")
                    el-dropdown.w-ui__header(size="medium" placement="top-start" @visible-change="handleVisible($event, 'allocation')")
                        span Dashboard
                        el-dropdown-menu.w-ui__header(slot="dropdown")
                            router-link(
                                :class="{ 'menu-active': isMenuActive('dashboard/account') }"
                                @click.native="changeViewName('Dashboard')"
                                :to="'/' + accountId + '/dashboard/account'"
                            )
                                el-dropdown-item Account

                            router-link(
                                v-if="isDashboardAccessAllowed"
                                :class="{ 'menu-active': isMenuActive('dashboard/allocation') }"
                                @click.native="changeViewName('Dashboard')"
                                :to="'/' + accountId + '/dashboard/allocation'"
                            )
                                el-dropdown-item Allocation

                .nav-item.has-dropdown(v-if="displayOnBoarding" :class="{'is-active': cmpLinkOnBoarding}")
                    el-dropdown.w-ui__header(size="medium" placement="top-start" @visible-change="handleVisible($event,'onboarding')")
                        span Onboarding
                        el-dropdown-menu.w-ui__header(slot="dropdown")
                            router-link(
                                v-if="hasUserAccessToManageTaxo"
                                :class="{ 'menu-active': isMenuActive('on-boarding/manage-taxonomy') }"
                                @click="changeViewName('Onboarding')"
                                :to="'/' + accountId + '/on-boarding/manage-taxonomy'"
                            )
                                el-dropdown-item Taxonomy
                            router-link(
                                v-if="hasUserAccessToDEM"
                                @click="changeViewName('Onboarding')"
                                :class="{ 'menu-active': isMenuActive('on-boarding/manage-data-entry') }"
                                :to="'/' + accountId + '/on-boarding/manage-data-entry'"
                            )
                                el-dropdown-item D.E.M
                            router-link(
                                v-if="hasUserAccessToCclone"
                                @click="changeViewName('Onboarding')"
                                :class="{ 'menu-active': isMenuActive('on-boarding/cclone') }"
                                :to="'/' + accountId + '/on-boarding/cclone'"
                            )
                                el-dropdown-item Cclone
                            router-link(
                                v-if="hasUserAccessToDSP"
                                @click="changeViewName('Onboarding')"
                                :class="{ 'menu-active': isMenuActive('on-boarding/partners') }"
                                :to="'/' + accountId + '/on-boarding/partners'"
                            )
                                el-dropdown-item Partners
                            router-link(
                                v-if="hasUserAccessToGeoradar"
                                @click="changeViewName('Onboarding')"
                                :class="{ 'menu-active': isMenuActive('on-boarding/georadar') }"
                                :to="'/' + accountId + '/on-boarding/georadar'"
                            )
                                el-dropdown-item Georadar

                .nav-item.has-dropdown(v-if="displayBuilderEntry" :class="{'is-active': cmpLinkBuilder}")
                    el-dropdown.w-ui__header(size="medium" placement="top-start" @visible-change="handleVisible($event,'builder')")
                        span Builder
                        el-dropdown-menu.w-ui__header(slot="dropdown")
                            router-link(
                                v-if="hasUserAccessToBuilderSegment"
                                @click.native="changeViewName('Builder')"
                                :class="{ 'menu-active': isMenuActive('builder/segment') }"
                                :to="'/' + accountId + '/builder/segment'"
                            )
                                el-dropdown-item Audience
                            router-link(
                                v-if="hasUserAccessToCclone"
                                @click.native="changeViewName('Builder')"
                                :class="{ 'menu-active': isMenuActive('builder/cclone') }"
                                :to="'/' + accountId + '/builder/cclone'"
                            )
                                el-dropdown-item Cclone

                .nav-item.has-dropdown(v-if="hasUserAccessToMonitoring" :class="{'is-active': cmpLinkMonitoring}")
                    el-dropdown.w-ui__header(size="medium" placement="top-start" @visible-change="handleVisible($event,'monitoring')")
                        span Monitoring
                        el-dropdown-menu.w-ui__header(slot="dropdown")
                            router-link(
                                @click.native="changeViewName('Monitoring')"
                                :class="{ 'menu-active': isMenuActive('monitoring/audiences') }"
                                :to="{ name: 'monitoring-audiences', params: { account_id: accountId } }"
                            )
                                el-dropdown-item Audiences
                            router-link(
                                @click.native="changeViewName('Monitoring')"
                                :class="{ 'menu-active': isMenuActive('monitoring/transfers') }"
                                :to="{ name: 'monitoring-transfers', params: { account_id: accountId } }"
                            )
                                el-dropdown-item Transfers

                .nav-item.has-dropdown(v-if="hasUserActiveBusinessApps" :class="{'is-active': cmpLinkBusinessApp}")
                    el-dropdown.w-ui__header(
                        size="medium"
                        placement="top-start"
                        @visible-change="handleVisible($event,'businessApp')"
                    )
                        span Business Apps
                        el-dropdown-menu.w-ui__header(slot="dropdown")
                            router-link(
                                v-for="businessApp in cmpProductAccountList"
                                @click.native="businessAppNavigation(businessApp)"
                                :class="{ 'menu-active': isBusinessAppsMenuActive(businessApp) }"
                                :to="'/' + accountId + '/businessapps/'"
                                :title="businessApp.label"
                            )
                                el-dropdown-item {{ businessApp.label }}

                router-link.nav-item.nav-monitoring(
                    v-else
                    @click.native="changeViewName('BusinessApps')"
                    :to="'/' + accountId + '/businessapps'") Business Apps

                router-link.nav-item.nav-monitoring(
                    v-if="isWeboAdmin"
                    @click.native="changeViewName('MarketPlace')"
                    :to="'/' + accountId + '/marketplace'") Marketplace

            div.app-header-action.l-flex-row
                template(v-if="displayAppSwitcher")
                    AppSwitcher(
                        :applications="switcherApplications"
                        :customer-info="customer"
                        :app-env="appEnv"
                        :logo-path="`${switcherLogoPath}/logos`"
                        :is-admin="isRootOrAdmin"
                        current-app="WAM"
                        class="mr-2"
                    )
                        div.switcher-icon
                            img(
                                src="@/assets/img/el-menu.svg"
                                width="20"
                                height="20"
                                alt="Application switcher"
                            )
                //- svg-icon.nav-action-item.icon-app-notification(name='notification' title='notifications')
                svg-icon.nav-action-item.nav-btn-icon(
                    name='user' title='User Settings'
                    @click.native="displayMenuUserSettings()")

                router-link.nav-action-item.nav-account-settings(
                    v-if="hasUserAccessToSettings"
                    @click.native="changeViewName('Settings')"
                    :to="'/' + accountId + '/settings'")
                    svg-icon.icon-account-settings(name='settings' title='Settings')

                div.menu.menu-user-settings(v-if="this.menuUserSettings")
                    //- div.menu-header
                        div.menu-title Interface Settings
                    //- div.menu-content
                        //- div.l-flex-row.l-align-center.user-settings-item
                        //-     label.flex-1(for="switch-dark-interface") Dark mode
                        //-     div.onoffswitch.small
                        //-         input(
                        //-             id="switch-dark-interface"
                        //-             name="switch-dark-interface"
                        //-             class="onoffswitch-checkbox"
                        //-             v-model="darkInterface"
                        //-             type="checkbox"
                        //-         )
                        //-         label(class="onoffswitch-label" for="switch-dark-interface")

                        //- div.l-flex-row.l-align-center.user-settings-item
                            //- span.flex-1 Theming
                            //- label.theme.theme__blue(
                            //-     for="theme-blue" :class="{'is-active': themeColor === 'blue'}")
                            //-     input(type="radio" v-model="themeColor" value="blue" id="theme-blue")
                            //- label.theme.theme__orange(
                            //-     for="theme-orange"
                            //-     :class="{'is-active': themeColor === 'orange'}")
                            //-     input(type="radio" v-model="themeColor" value="orange" id="theme-orange")
                            //- label.theme.theme__pink(
                            //-     for="theme-pink"
                            //-     :class="{'is-active': themeColor === 'pink'}")
                            //-     input(type="radio" v-model="themeColor" value="pink" id="theme-pink")
                            //- label.theme.theme__yellow(
                            //-     for="theme-yellow"
                            //-     :class="{'is-active': themeColor === 'yellow'}")
                            //-     input(type="radio" v-model="themeColor" value="yellow" id="theme-yellow")

                        //-div.l-flex-row.l-align-center.user-settings-item(v-if="hasUserAccessToSettings")
                            label.flex-1 Client
                            label.client.client-weborama(
                                for="client-weborama"
                                :class="{'is-active': clientChoice === 'weborama'}") Weborama
                                input(type="radio" v-model="clientChoice" value="weborama" id="client-weborama" checked)
                            label.client.client-publicis(
                                for="client-publicis"
                                :class="{'is-active': clientChoice === 'publicis'}") Publicis
                                input(type="radio" v-model="clientChoice" value="publicis"  id="client-publicis")

                        //-div.l-flex-row.l-align-center.user-settings-item
                            label.flex-1(for="switch-tutorial") Tutorial
                            div.onoffswitch.small
                                input(
                                    id="switch-tutorial"
                                    name="switch-tutorial"
                                    class="onoffswitch-checkbox"
                                    type="checkbox"
                                    unchecked
                                )
                                label(class="onoffswitch-label" for="switch-tutorial")

                        //-div.l-flex-row.l-align-center.user-settings-item(v-if="hasUserAccessToSettings")
                            router-link(
                                @click.native="changeViewName('Settings')"
                                :to="'/' + accountId + '/settings'") Preferences

                    div.menu-footer.menu-footer-user-settings.l-flex-row.l-align-center(@click="logout()")
                        div logout
                        svg-icon.logout-user-settings(name='logout' title='logout')
                div.overlay-close_light(
                    v-if="this.coverClose"
                    @click="displayMenuUserSettings()")

                //- @TODO: investigate why component Transfers is created whn opening FormCreateTransfer in Builder
                //- after opening FormCreateTransfer in Moniroting
                //-keep-alive(:exclude="['Monitoring']")
                    router-view
    keep-alive
        router-view

    dialogs-wrapper(name="default")
</template>

<script>
import { capitalize, isEmpty, includes } from 'lodash'
import Cookies from 'js-cookie'
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import FormExportData from '@/components/builder/FormExportData'
// import customerDetail from '@/assets/json/appMock.json'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
// import AppSwitcher from '@/components/common/AppSwitcher.vue'
import AppSwitcher from '@weborama/app-switcher-vue2'
import axios from 'axios'
import Vue from 'vue'

dayjs.extend(utc)


export default {
    name: 'App',

    components: {
        FormExportData,
        AppSwitcher,
        // AppSwitcherPkg
    },

    data() {
        return {
            view_name: 'Builder',
            coverClose: false,
            menuUserSettings: false,
            darkInterface: false,
            themeColor: 'blue',
            clientChoice: 'weborama',
            currentDropdown: null,
            isLinked: false,
            customer: {},
            switcherApplications: {},
            switcherLogoPath: process.env.VUE_APP_PLATFORM_APPS_URL,
            isRootOrAdmin: false,
            logoPath: `${process.env.VUE_APP_PLATFORM_APPS_URL}/logos/dam.svg`,
            currentBusinessApp: null
        }
    },

    computed: {
        ...mapState('notifications', {
            notifications: state => state
        }),

        ...mapState('account', {
            accountId: state => state.accountId,
            accountLabel: state => state.label,
            userRole: state => state.userRole,
            isAccountAllowed: state => state.isAccountAllowed,
            allocationDashboardActivated: state => state.settings.allocationDashboardActivated
        }),

        ...mapState('ui/settings', {
            previousRoute: state => state.previousRoute
        }),

        ...mapState('data/settings', {
            productAccountList: state => state.businessApps.productAccountList
        }),

        ...mapState('ui/manageTaxonomy', {
            hasCounterActivated: state => state.hasCounterActivated
        }),

        ...mapState('exports', {
            displayExportForm: state => state.formExport.display
        }),

        ...mapGetters('account', [
            'getAccessToBuilderSegment',
            'getAccessToCclone',
            'getAccessToSettings',
            'getAccessToDEM',
            'getAccessToDSP',
            'getAccessToGeoradar',
            'getAccessToMonitoring',
            'getAccessToManageTaxo'
        ]),

        cmpLinkBuilder() {
            return includes(this.$route.path, 'segment') || includes(this.$route.path, 'builder/cclone') || this.currentDropdown === 'builder'
        },

        cmpLinkMonitoring() {
            return includes(this.$route.path, 'monitoring')
        },

        cmpLinkOnBoarding() {
            return (
                includes(this.$route.path, 'manage-taxonomy') ||
                includes(this.$route.path, 'manage-data-entry') ||
                includes(this.$route.path, 'on-boarding/cclone') ||
                includes(this.$route.path, 'on-boarding/georadar') ||
                includes(this.$route.path, 'on-boarding/partners') ||
                this.currentDropdown === 'onboarding'
            )
        },

        cmpLinkBusinessApp() {
            return includes(this.$route.path, 'businessapps') || this.currentDropdown === 'businessApp'
        },

        cmpLinkDashboard() {
            return includes(this.$route.path, 'dashboard') || this.currentDropdown === 'allocation'
        },

        cmpProductAccountList() {
            return this.productAccountList.filter((product) => {
                if (product.privileges) {
                    if (this.userRole === 'webo_admin') {
                        return true
                    }

                    if (!['webo_admin', 'webo_employee'].includes(this.userRole)) {
                        return false
                    }

                    if (this.userRole === 'webo_employee' && product.privileges[0].method_right === 'weboadmin') {
                        return false
                    }

                    return true
                }
                return true
            })
        },

        isMenuActive() {
            return (path) => includes(this.$route.path, path)
        },

        isBusinessAppsMenuActive() {
            return (businessApp) => {
                if (includes(this.$route.path, 'businessapps')) {
                    return this.currentBusinessApp?.id === businessApp.id
                }
                return false
            }
        },

        hasUserAccessToBuilderSegment() {
            return this.getAccessToBuilderSegment()
        },

        hasUserAccessToCclone() {
            return this.getAccessToCclone()
        },

        hasUserAccessToMonitoring() {
            return this.getAccessToMonitoring()
        },

        hasUserAccessToSettings() {
            return this.getAccessToSettings()
        },

        hasUserActiveBusinessApps() {
            return !isEmpty(this.cmpProductAccountList)
        },

        displayBuilderEntry() {
            return this.hasUserAccessToBuilderSegment || this.hasUserAccessToCclone
        },

        hasUserAccessToDEM() {
            return this.getAccessToDEM()
        },

        hasUserAccessToDSP() {
            return this.getAccessToDSP()
        },

        hasUserAccessToGeoradar() {
            return this.getAccessToGeoradar()
        },

        hasUserAccessToManageTaxo() {
            return this.getAccessToManageTaxo()
        },

        isWeboAdmin() {
            return this.userRole === 'webo_admin'
        },

        isWeboEmployee() {
            return this.userRole === 'webo_employeee'
        },

        displayOnBoarding() {
            return this.hasUserAccessToCclone || this.hasUserAccessToManageTaxo || this.hasUserAccessToDEM || this.hasUserAccessToDSP
        },

        isDashboardAccessAllowed() {
            return this.allocationDashboardActivated && (this.isWeboAdmin || this.isWeboEmployee || this.$store.getters['account/getAccessToMonitoring']())
        },

        appEnv() {
            const prod = ['production', 'staging']
            const preprod = ['preprod']
            // const dev = ['desktop', 'development', 'integration']

            if (process.env.NODE_ENV === 'production') {
                if (prod.includes(process.env.VUE_APP_ENV)) {
                    return 'prod'
                } else if (preprod.includes(process.env.VUE_APP_ENV)) {
                    return 'preprod'
                }
            }

            return 'dev'
        },

        displayAppSwitcher() {
            return (Object.keys(this.switcherApplications).length > 0 && this.isLinked) || this.isRootOrAdmin
        }
    },

    watch: {
        themeColor: {
            immediate: true,
            handler(value) {
                this.addThemeOnBody(value)
            }
        },

        'notifications.interfaceMessages': {
            handler() {
                this.displayInterfaceMessages()
            },
            deep: true
        }
    },

    mounted() {
        for (const type of ['success', 'info', 'warning', 'error']) {
            this.$store.watch(this.$store.getters['notifications/getLast' + capitalize(type) + 'Notification'], notification => {
                this.$notify({
                    type: type,
                    title: type,
                    duration: this.defineNotificationDuration(type),
                    message: notification.message
                })
            })
        }
        this.$nextTick(async () => {
            await this.getCustomerApplication()
            await this.privilegeAdmin()
            await this.getPlatformApplications()
        })
    },

    methods: {
        ...mapActions('account', ['retrieveAccountId', 'retrieveItems', 'retrieveUserRights']),
        ...mapMutations('account', ['setUserRole', 'setCustomer']),
        ...mapMutations('ui/settings', ['setPreviousRoute']),
        ...mapMutations('exports', ['setExportForm']),
        ...mapMutations('data/settings', ['setSelectedBusinessApp']),

        businessAppNavigation(businessApp) {
            this.currentBusinessApp = businessApp
            this.changeViewName('BusinessApps')
            this.setSelectedBusinessApp({'businessApp': businessApp})
        },

        handleVisible(event, entry) {
            if (event) {
                this.currentDropdown = entry
                this.blurActiveElement()
            } else {
                this.currentDropdown = null
            }
        },

        addThemeOnBody(themeValue) {
            document.body.setAttribute('theme', themeValue)
        },

        changeViewName(name) {
            if (this.view_name === 'Settings' && name === 'Settings') {
                window.dispatchEvent(new Event('hook:settings'))
            } else {
                if (this.menuUserSettings) this.displayMenuUserSettings()
                if (name === 'Settings') {
                    if (this.previousRoute === null) {
                        // Make sure we can't leave ManageTaxonomy view if we still have unsaved changes
                        if (this.hasCounterActivated) return
                        this.$router.push({ path: '/' + this.accountId + '/builder/segment' })
                    }
                    if (name === this.view_name && this.previousRoute !== this.$route.path) {
                        this.$router.push({ path: this.previousRoute })
                    }
                }
                this.view_name = name
            }
        },

        logout() {
            this.displayMenuUserSettings()
            this.$keycloak.logoutFn()
        },

        displayMenuUserSettings() {
            this.coverClose = !this.coverClose
            this.menuUserSettings = !this.menuUserSettings
        },

        closeForm() {
            this.setExportForm({
                display: false,
                type: ''
            })
        },

        defineNotificationDuration(type) {
            if (type === 'error') return 15000
            else if (type === 'warning') return 10000
            else if (type === 'success') return 5000
            else return 5000
        },

        displayInterfaceMessages() {
            [...Object.values(this.notifications.interfaceMessages)].forEach((message, index) => {
                this.addInterfaceMessage(message, index)
            })
        },

        addInterfaceMessage(message, index) {
            // Checking that the message is still active, not expired and has not already been placed in cookies
            const cookies = Cookies.get()
            if (message.expired_at < new Date() || message.status !== 'active' || cookies[`alert_id_${message.id}`]) return

            // Place the message id in cookies and print message
            this.$message({
                showClose: true,
                duration: 0,
                offset: (index + 1) * 60,
                onClose() {
                    const expires = dayjs.utc(message.expired_at).toDate()
                    Cookies.set(`alert_id_${message.id}`, message.id, { expires })
                },
                dangerouslyUseHTMLString: true,
                type: message.priority,
                message: `<strong style="font-size: 18px">${message.title}</strong><br><div>${message.message}</div>`
            })
        },

        blurActiveElement() {
            if (document.activeElement) {
                document.activeElement.blur()
            }
        },

        async getCustomerApplication() {
            const { token } = Vue.prototype.$keycloak
            const config = {
                headers: { Authorization: `Bearer ${ token }` }
            }
            try {
                const { data } = await axios.get(`${process.env.VUE_APP_DIP_URL}/admin/customer/translate/${this.accountId}/WAM`, config)
                if (data && data.id) {
                    this.customer = data // data
                    this.setCustomer(data)
                    this.isLinked = true
                } else {
                    this.setCustomer(null)
                    this.customer = {} // customerDetail for dev test purpose
                    this.isLinked = false
                }

            } catch (error) {
                // eslint-disable-next-line no-console
                console.error({ error })
                this.setCustomer(null)
                this.customer = {} // customerDetail for dev test purpose
                this.isLinked = false
            }
        },

        updateLinkedInfo(value) {
            this.isLinked = value
        },

        async getPlatformApplications() {
            try {
                const response = await axios.get(`${process.env.VUE_APP_PLATFORM_APPS_URL}/applications.json`)
                if (response) {
                    const { data } = response
                    if (data.content) {
                        this.switcherApplications = data.content
                    }
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error)
            }
        },

        async privilegeAdmin() {
            const { token } = Vue.prototype.$keycloak
            const { sub } = Vue.prototype.$keycloak.tokenParsed
            const config = { headers: { Authorization: `Bearer ${ token }` } }
            try {
                const { data } = await axios.get(`${process.env.VUE_APP_DIP_URL}/user/${sub}/portal-info`, config)
                if (data) {
                    this.isRootOrAdmin = ['admin', 'root'].includes(data.privilege)
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error({ error })
                this.isRootOrAdmin = false
            }
        },
    }
}
</script>

<style>
.switcher-icon {
    line-height: 0;
    margin-right: 4px
}

.switcher-icon:hover {
    cursor: pointer;
}
.menu-active .el-dropdown-menu__item {
    background-color: rgba(255, 255, 255, .3);
}
</style>
